module.exports = __webpack_public_path__ + "img/checked-guardian.6a5da7b2.svg";